import { useEffect, useRef } from 'react';

// Pre-selects the only option when a select has exactly one choice and nothing
// is selected yet (e.g. a manager assigned to a single store). `options` is an
// array of objects with an `id`; `value` is the current select value; `onSelect`
// receives the stringified id to store.
export default function useAutoSelectSingle(options, value, onSelect) {
  const onSelectRef = useRef(onSelect);
  onSelectRef.current = onSelect;
  useEffect(() => {
    if (options.length === 1 && !value) {
      onSelectRef.current(String(options[0].id));
    }
  }, [options, value]);
}
